import { useEffect, useState } from 'react';
import { LeadsPro } from '../../components/LeadsPro';
import { RequestedLeads } from '../../components/RequestedLeads';
import { LeadDetails } from '../../components/LeadDetails';
import { Lead } from '../../types/lead';
import { Loader2 } from 'lucide-react';
import { Toaster, toast } from 'sonner';
import { useLocation, useSearchParams } from 'react-router-dom';
import { CallAPIGetPromise, CallAPIPostPromise } from 'Common/commaon';
import { getDecodeId } from 'slices/userProfile/thunk';
import { ApplyLeadConfirmation } from 'components/ApplyLeadConfirmation';
import { AcceptedLeads } from 'components/AcceptedLeads';
import { getDecodeUserType } from 'slices/auth/login/thunk';
import axios from 'axios';
import apiUrl from 'slices/apiEndpoint';
import { Alert, AlertDescription } from 'components/ui/alert';
import FeaturePlan from './featureModal';
import { LeadHistory } from 'components/HistoryLeads';
import './lead-management.css';


const LeadsHistory =()=> {
  const [searchParams, setSearchParams] = useSearchParams();
  const [currentView, setCurrentView] = useState<any>('lead-history');
  const [selectedLeadId, setSelectedLeadId] = useState<string | null>(null);
  const [openLeads, setOpenLeads] = useState<any>([]);
  const [AcceptedLeadsList, setAcceptedLeads] = useState<any>([]);
  const [requestedLeads, setRequestedLeads] = useState<Lead[]>([]);
 const [refresh,setIsRefresh]=useState(false)
 const [historicalLeads, setHistoricalLeads] = useState<any[]>([
  
]);
 const [loading,setLoading]=useState(true)
  const handleViewDetails = (leadId: string) => {
    setSelectedLeadId(leadId);
    setCurrentView('lead-details');
    const next = new URLSearchParams(searchParams);
    next.set('leadId', String(leadId));
    setSearchParams(next, { replace: true });
  };
  useEffect(()=>{
    setLoading(true)
    CallAPIGetPromise(`/jobs/getHistoryJobs/${getDecodeId()}`).then((res:any)=>{
      if(res.data){
        setHistoricalLeads(res.data)
          }
        }).catch((e:any)=>{
          console.log(e)
        }).finally(()=>{
          setLoading(false)
        })

  },[refresh])
  const getSelectedLead = (): Lead | undefined => {
    if (!selectedLeadId) return undefined;
    
    const lead = historicalLeads.find(l => String(l.id) === String(selectedLeadId));
    return lead;
  };
  const location = useLocation()
  const selectedLead = getSelectedLead();
  const handleBack = () => {
    setSelectedLeadId(null);
    setCurrentView("lead-history")
    const next = new URLSearchParams(searchParams);
    next.delete('leadId');
    setSearchParams(next, { replace: true });

    
  };
  useEffect(() => {
    const leadId = searchParams.get('leadId');
    if (!leadId || loading) return;
    if (historicalLeads.some((lead: any) => String(lead.id) === leadId)) {
      setSelectedLeadId(leadId);
      setCurrentView('lead-details');
    }
  }, [searchParams, loading, historicalLeads]);
  return (
    <div className='page-content tailwind-prefix lead-management-page'>
   <div className="lead-management-shell">
      <Toaster position="top-right" />
{ loading ?    <div className="lead-management-loading-overlay"
                       style={{
                         position: "absolute",
                         inset: 0,
                         minHeight:window.innerHeight,
                         backgroundColor: "rgba(255, 255, 255, 0.8)",
                         backdropFilter: "blur(4px)",
                         zIndex: 50,
                         borderRadius: "8px",
                         display: "flex",
                         alignItems: "center",
                         justifyContent: "center",
                       }}
                     >
                       <div
                         style={{
                           display: "flex",
                           flexDirection: "column",
                           alignItems: "center",
                           gap: "12px",
                         }}
                       >
                         <Loader2
                           style={{
                             height: "40px",
                             width: "40px",
                             color: "#1f57d6",
                             animation: "spin 1s linear infinite",
                           }}
                         />
                         <p style={{ fontSize: "14px", color: "#6b7280" }}>Processing...</p>
                 
                         {/* Inline keyframes */}
                         <style>{`
                           @keyframes spin {
                             from { transform: rotate(0deg); }
                             to { transform: rotate(360deg); }
                           }
                         `}</style>
                       </div>
                     </div> :<>
                     
   {currentView === 'lead-history' &&
        <LeadHistory
          leads={historicalLeads}
          onViewDetails={handleViewDetails}
        />}
 
 {currentView === 'lead-details'  && (
        <LeadDetails
          lead={selectedLead}
          onBack={handleBack}
        />
      )}
     
                     
                     </>}
     


 
    
    </div>

    </div>
 
  );
}

export default LeadsHistory
